/**
 * 将 published-works / discovery / library 等来源归一成预览 DTO。
 */

function asNum(v) {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

function asStr(v) {
  return v == null ? '' : String(v)
}

function uniqUrls(list) {
  const out = []
  const seen = new Set()
  for (const u of list || []) {
    const s = asStr(u).trim()
    if (!s || seen.has(s)) continue
    seen.add(s)
    out.push(s)
  }
  return out
}

/**
 * @param {object} raw
 * @param {{ platform?: string, account?: object, proxyUrl?: (url: string) => string }} [opts]
 */
export function normalizeContent(raw, opts = {}) {
  if (!raw || typeof raw !== 'object') {
    return emptyDto(opts.platform || '')
  }

  const platform = asStr(opts.platform || raw.platform || raw._account?.platform || '').toLowerCase()
  const account = opts.account || raw._account || null
  const proxy = typeof opts.proxyUrl === 'function' ? opts.proxyUrl : (u) => u

  const coverRaw = asStr(raw.cover_url || raw.coverUrl || '')
  let imageUrls = uniqUrls(raw.image_urls || raw.imageUrls || [])
  if (!imageUrls.length && coverRaw) imageUrls = [coverRaw]

  const contentHtml = asStr(raw.content_html || raw.contentHtml || '')
  const content = asStr(raw.content || raw.desc || '')
  const title = asStr(raw.title || '') || '(无标题)'

  const authorName =
    asStr(raw.author_name || raw.authorName || '') ||
    asStr(account?.display_name || account?.account_id || '')
  const authorAvatarRaw = asStr(
    raw.author_avatar || raw.authorAvatar || account?.avatar_url || '',
  )

  const noteType = asStr(raw.note_type || raw.type || '').toLowerCase()
  const videoUrl = asStr(raw.video_url || raw.video_addr || raw.videoUrl || '')
  const isVideo =
    noteType.includes('video') ||
    Boolean(videoUrl) ||
    platform === 'douyin'

  return {
    platform,
    workId: asStr(raw.note_id || raw.work_id || raw.aweme_id || raw.id || ''),
    title,
    content,
    contentHtml,
    coverUrl: coverRaw ? proxy(coverRaw) : '',
    imageUrls: imageUrls.map((u) => proxy(u)),
    videoUrl,
    noteUrl: asStr(raw.note_url || raw.noteUrl || raw.source_note_url || ''),
    noteType: noteType || (isVideo ? 'video' : 'normal'),
    isVideo,
    authorName,
    authorAvatar: authorAvatarRaw ? proxy(authorAvatarRaw) : '',
    authorId: asStr(raw.author_id || raw.authorId || ''),
    publishedAt: asStr(raw.published_at || raw.publishedAt || ''),
    views: asNum(raw.views),
    likes: asNum(raw.likes),
    comments: asNum(raw.comments),
    collects: asNum(raw.collects),
    shares: asNum(raw.shares),
    hearts: asNum(raw.hearts),
    recommend: asNum(raw.recommend),
    tags: Array.isArray(raw.tags) ? raw.tags : [],
    accountId: asStr(account?.account_id || raw.account_id || ''),
    accountDisplayName: asStr(account?.display_name || ''),
    detailWarning: asStr(raw.detail_warning || raw.detailWarning || ''),
    raw,
  }
}

function emptyDto(platform) {
  return {
    platform: asStr(platform).toLowerCase(),
    workId: '',
    title: '(无标题)',
    content: '',
    contentHtml: '',
    coverUrl: '',
    imageUrls: [],
    videoUrl: '',
    noteUrl: '',
    noteType: 'normal',
    isVideo: false,
    authorName: '',
    authorAvatar: '',
    authorId: '',
    publishedAt: '',
    views: 0,
    likes: 0,
    comments: 0,
    collects: 0,
    shares: 0,
    hearts: 0,
    recommend: 0,
    tags: [],
    accountId: '',
    accountDisplayName: '',
    detailWarning: '',
    raw: null,
  }
}

export function formatCount(n) {
  const v = asNum(n)
  if (v >= 100000000) return `${(v / 100000000).toFixed(1)}亿`
  if (v >= 10000) return `${(v / 10000).toFixed(1)}万`
  return String(v)
}

export function mergeContent(base, patch) {
  if (!patch) return base
  const merged = { ...base }
  const keys = [
    'content', 'contentHtml', 'coverUrl', 'videoUrl', 'noteUrl',
    'noteType', 'authorName', 'authorAvatar', 'authorId', 'publishedAt',
    'workId',
  ]
  for (const k of keys) {
    if (patch[k] != null && patch[k] !== '') merged[k] = patch[k]
  }
  // 避免补全失败时用占位标题盖掉列表里的真实标题
  if (patch.title && patch.title !== '(无标题)') {
    merged.title = patch.title
  }
  if (patch.detailWarning) {
    merged.detailWarning = patch.detailWarning
  }
  if (Array.isArray(patch.imageUrls) && patch.imageUrls.length) {
    merged.imageUrls = patch.imageUrls
  }
  for (const k of ['views', 'likes', 'comments', 'collects', 'shares', 'hearts', 'recommend']) {
    if (patch[k] != null && Number(patch[k]) > 0) merged[k] = Number(patch[k])
  }
  if (Array.isArray(patch.tags) && patch.tags.length) merged.tags = patch.tags
  if (patch.isVideo != null) merged.isVideo = Boolean(patch.videoUrl) || patch.isVideo || merged.isVideo
  if (patch.videoUrl) merged.isVideo = true
  return merged
}
